import { MenuStates } from '@frontend-site/main-header/domain';
import { ProjectResolver } from '@frontend-site/shared/core';
import { TM_REPORTS_ROUTES } from './tm-reports-routes';
import { LoopbackComponent, OldSitePendingChangesGuard } from '@frontend-site/shared/hybrid';
import { PanayaRoute } from '@frontend-site/shared/router-store';
import { ProjectLandingPageComponent } from '@frontend-site/project/features';
import { ForesightDirectLinkToAnalysisGuard } from '../guards/foresight-direct-link-to-analysis.guard';
import { ForesightDirectLinkToFtsGuard } from '../guards/foresite-direct-link-to-fts.guard';


export const TM_ROUTES: ReadonlyArray<PanayaRoute> = [
    {
        path: 'tm/:projectId',
        resolve: { loadProject: ProjectResolver },
        data: { menuState: MenuStates.PROJECT },
        children: [
            { path: '', component: ProjectLandingPageComponent, pathMatch: 'full' },
            {
                // eslint-disable-next-line @nx/enforce-module-boundaries
                path: 'project/content/deliveredSp',
                loadChildren: () =>
                    import('../../../panaya-temp/src/modules/delivered-sp/delivered-sp.module').then(
                        (m) => m.DeliveredSpModule
                    )
            },
            {
                path: 'project',
                data: { navState: 'tm.project' },
                canDeactivate: [OldSitePendingChangesGuard],
                children: [
                    {
                        path: 'dashboard',
                        component: LoopbackComponent,
                        data: { navState: 'tm.project.dashboard', rememberMe: { pageId: 'project_dashboard', group: 'project' } }
                    },
                    {
                        path: 'customDashboard',
                        component: LoopbackComponent,
                        data: { navState: 'tm.project.customDashboard' }
                    },
                    {
                        path: 'organizationOverview',
                        data: { navState: 'tm.project.organizationOverview' },
                        children: [
                            {
                                path: '',
                                redirectTo: 'dashboard',
                                pathMatch: 'full'
                            },
                            {
                                path: 'dashboard',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.organizationOverview.dashboard' }
                            },
                            {
                                path: 'potentialTechnicalDebt',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.organizationOverview.potentialTechnicalDebt' }
                            },
                            {
                                path: 'componentDetails',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.organizationOverview.componentDetails' }
                            }
                        ]
                    },
                    {
                        path: 'sfComponents',
                        component: LoopbackComponent,
                        data: { navState: 'tm.project.sfComponentsList' }
                    },
                    {
                        path: 'navContent',
                        component: LoopbackComponent,
                        data: { navState: 'tm.project.navContent' }
                    },
                    {
                        path: 'content',
                        data: { navState: 'tm.project.content' },
                        children: [
                            {
                                path: 'patchesList',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.content.patchesList', rememberMe: true }
                            },
                            {
                                path: 'analyzedObjectsList',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.content.analyzedObjectsList' }
                            },
                            {
                                path: 'recommendedPatches',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.content.recPatches' }
                            },
                            {
                                path: 'uploadPtlConfirmation/:ticketId',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.content.uploadPtlConfirmation' }
                            },
                            {
                                path: 'reviewAndAnalyze',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.content.reviewAndAnalyze' }
                            },
                            {
                                path: 'deliveredSp',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.content.deliveredSp' }
                            },
                            {
                                path: 'projectSpNotes',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.content.projectSpNotes' }
                            },
                            {
                                path: 'sapNotesInsights',
                                component: LoopbackComponent,
                                data: { navState: 'tm.project.content.sapNotesInsights' }
                            }
                        ]
                    }
                ]
            },
            {
                path: 'directScriptViewer/:id/:stepIndex/:stepSide/:executionId',
                component: LoopbackComponent,
                data: { navState: 'tm.directScriptViewer' }
            },
            {
                path: 'stepShowEvidence/:id',
                component: LoopbackComponent,
                data: { navState: 'tm.stepShowEvidence' }
            },
            {
                path: 'defects',
                data: { navState: 'tm.defects' },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'grid'
                    },
                    {
                        path: 'defectStepsToRepro/:id',
                        component: LoopbackComponent,
                        data: { navState: 'tm.defects.defectStepsToRepro' }
                    },
                    { path: 'grid', component: LoopbackComponent, data: { navState: 'tm.defects.defectsGrid' } },
                    {
                        path: 'defectDetails/:id',
                        component: LoopbackComponent,
                        data: { navState: 'tm.defects.defectDetails' }
                    },
                    {
                        path: 'defectFromList/:id',
                        component: LoopbackComponent,
                        data: { navState: 'tm.defects.defectFromList' }
                    },
                    { path: 'influence', component: LoopbackComponent, data: { navState: 'tm.defects.influence' } }
                ]
            },
            {
                path: 'directDefectDetails',
                component: LoopbackComponent,
                data: { navState: 'tm.directDefectDetailsWrapper' }
            },
            {
                path: 'development',
                data: { navState: 'tm.development' },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'list'
                    },
                    {
                        path: 'list',
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.list', rememberMe: { pageId: 'development_list', group: 'project' } }
                    },
                    {
                        path: 'board',
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.board' }
                    },
                    {
                        path: 'requirementDetails/:requirementId',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.requirementDetails' }
                    },
                    {
                        path: 'requrementDetails/:requirementId',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.requrementDetails' }
                    },
                    {
                        path: 'featureDetails/:featureId',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.featureDetails' }
                    },
                    {
                        path: 'taskDetails/:taskId',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.taskDetails' }
                    },
                    {
                        path: 'defectDetails/:id',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.defectDetails' }
                    }
                ]
            },
            {
                path: 'requirements',
                data: { navState: 'tm.requirements' },
                children: [
                    {
                        path: '',
                        redirectTo: 'list',
                        pathMatch: 'full'
                    },
                    {
                        path: 'requirementDetails/:requirementId',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.requirements.requirementDetails' }
                    },
                    {
                        path: 'featureDetails/:featureId',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.requirements.featureDetails' }
                    },
                    {
                        path: 'taskDetails/:taskId',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.taskDetails' }
                    },
                    {
                        path: 'defectDetails/:id',
                        canDeactivate: [OldSitePendingChangesGuard],
                        component: LoopbackComponent,
                        data: { navState: 'tm.development.defectDetails' }
                    },
                    {
                        path: 'list',
                        component: LoopbackComponent,
                        data: { navState: 'tm.requirements.list', rememberMe: { pageId: 'requirements_list', group: 'project' } }
                    }
                ]
            },
            {
                path: 'execution',
                data: { navState: 'tm.execution', rememberMe: { pageId: 'execution', group: 'project' } },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'tree'
                    },
                    {
                        path: 'directTestDetails/:id',
                        canDeactivate: [OldSitePendingChangesGuard],
                        data: { navState: 'tm.execution.directTestDetailsWrapper' },
                        component: LoopbackComponent
                    },
                    {
                        path: 'testDetails/:id',
                        canDeactivate: [OldSitePendingChangesGuard],
                        data: { navState: 'tm.execution.directTestDetails' },
                        component: LoopbackComponent
                    },
                    {
                        path: 'testDetails/:id/:stepOrder',
                        canDeactivate: [OldSitePendingChangesGuard],
                        data: { navState: 'tm.execution.directStepDetails' },
                        component: LoopbackComponent
                    },
                    {
                        path: 'tree',
                        data: { navState: 'tm.execution.treeView' },
                        children: [
                            {
                                path: 'root',
                                component: LoopbackComponent,
                                data: { navState: 'tm.execution.treeView.root', rememberMe: true }
                            },
                            {
                                path: ':id',
                                canDeactivate: [OldSitePendingChangesGuard],
                                data: { navState: 'tm.execution.treeView.entity' },
                                children: [
                                    {
                                        path: 'testDetails',
                                        component: LoopbackComponent,
                                        data: { navState: 'tm.execution.treeView.entity.testDetails' }
                                    },
                                    {
                                        path: 'projectDetails',
                                        component: LoopbackComponent,
                                        data: { navState: 'tm.execution.treeView.entity.projectDetails' }
                                    },
                                    {
                                        path: 'folderDetails',
                                        component: LoopbackComponent,
                                        data: { navState: 'tm.execution.treeView.entity.folderDetails' }
                                    },
                                    {
                                        path: 'bpDetails',
                                        component: LoopbackComponent,
                                        data: { navState: 'tm.execution.treeView.entity.bpDetails' }
                                    },
                                    {
                                        path: 'cycleDetails',
                                        component: LoopbackComponent,
                                        data: { navState: 'tm.execution.treeView.entity.cycleDetails' }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'list',
                        data: { navState: 'tm.execution.listView' },
                        children: [
                            {
                                path: 'testFromList/:id',
                                canDeactivate: [OldSitePendingChangesGuard],
                                data: { navState: 'tm.execution.listView.testFromList' },
                                component: LoopbackComponent
                            },
                            {
                                path: 'testDetails/:id',
                                canDeactivate: [OldSitePendingChangesGuard],
                                data: { navState: 'tm.execution.listView.testDetails' },
                                component: LoopbackComponent
                            },
                            {
                                path: 'testsGrid',
                                component: LoopbackComponent,
                                data: { navState: 'tm.execution.listView.testsGrid', rememberMe: true }
                            },
                            { path: 'stepsGrid', component: LoopbackComponent, data: { navState: 'tm.execution.listView.stepsGrid' } }
                        ]
                    },
                    {
                        path: 'playlistExecutionMonitor',
                        component: LoopbackComponent,
                        canDeactivate: [OldSitePendingChangesGuard],
                        data: { navState: 'tm.execution.playlistExecutionMonitor' }
                    },
                    {
                        path: 'testbox',
                        component: LoopbackComponent,
                        canDeactivate: [OldSitePendingChangesGuard],
                        data: { navState: 'tm.execution.testbox', rememberMe: true }
                    },
                    {
                        path: 'myTests',
                        component: LoopbackComponent,
                        data: { navState: 'tm.execution.myTests' }
                    }
                ]
            },
            {
                path: 'ia',
                data: { navState: 'tm.ia' },
                children: [
                    {
                        path: 'corrections',
                        data: { navState: 'tm.ia.corrections' },
                        children: [
                            {
                                path: 'correctionPlan',
                                component: LoopbackComponent,
                                data: {
                                    navState: 'tm.ia.corrections.correctionPlan',
                                    rememberMe: { pageId: 'corrections_correctionPlan', group: 'project' }
                                }
                            },
                            {
                                path: 'list',
                                component: LoopbackComponent,
                                data: { navState: 'tm.ia.corrections.list' }
                            },
                            { path: 'grid', component: LoopbackComponent, data: { navState: 'tm.ia.corrections.grid' } },
                            {
                                path: 'correctionDetails/:id',
                                component: LoopbackComponent,
                                data: { navState: 'tm.ia.corrections.correctionDetails' }
                            },
                            {
                                path: 'correctionDetailsFromList/:id',
                                component: LoopbackComponent,
                                data: { navState: 'tm.ia.corrections.correctionDetailsFromList' }
                            },
                            {
                                path: 'correctionDetailsFromIssueList/:id/:issueId',
                                component: LoopbackComponent,
                                data: { navState: 'tm.ia.corrections.correctionDetailsFromIssueList' }
                            }
                        ]
                    },
                    {
                        path: 'issues',
                        data: { navState: 'tm.ia.issues' },
                        children: [{ path: 'grid', component: LoopbackComponent, data: { navState: 'tm.ia.issues.list' } }]
                    },
                    {
                        path: 'myCorrectionsReport',
                        component: LoopbackComponent,
                        data: { navState: 'tm.ia.myCorrectionsReport' }
                    }
                ]
            },
            {
                path: 'releaseDynamix',
                data: { navState: 'tm.rdx' },
                children: [
                    {
                        path: ':companyId',
                        data: { navState: 'tm.rdx.company' },
                        children: [
                            {
                                path: 'project',
                                data: { navState: 'tm.rdx.company.project' },
                                children: [
                                    {
                                        path: 'requirements',
                                        data: { navState: 'tm.rdx.company.project.requirements' },
                                        children: [
                                            {
                                                path: '',
                                                redirectTo: 'list',
                                                pathMatch: 'full'
                                            },
                                            {
                                                path: 'board',
                                                data: { navState: 'tm.rdx.company.project.requirements.board' },
                                                component: LoopbackComponent
                                            },
                                            {
                                                path: 'list',
                                                data: {
                                                    navState: 'tm.rdx.company.project.requirements.list',
                                                    rememberMe: { pageId: 'rdx_project_requirements_list', group: 'project' }
                                                },
                                                component: LoopbackComponent
                                            },
                                            {
                                                path: 'entityNotFoundError',
                                                data: { navState: 'tm.rdx.company.project.requirements.entityNotFoundError' },
                                                component: LoopbackComponent
                                            },
                                            {
                                                path: 'requirementDetails/:requirementId',
                                                data: { navState: 'tm.rdx.company.project.requirements.requirementDetails' },
                                                component: LoopbackComponent
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: 'trialSetup',
                data: { navState: 'tm.trialSetup' },
                children: [
                    {
                        path: 'noEtlMode',
                        data: { navState: 'tm.trialSetup.noEtlMode' },
                        component: LoopbackComponent
                    },
                    {
                        path: 'etlProcessing',
                        component: LoopbackComponent,
                        data: { navState: 'tm.trialSetup.etlProcessing' }
                    },
                    {
                        path: 'uploadPatch',
                        component: LoopbackComponent,
                        data: { navState: 'tm.trialSetup.uploadPatch' }
                    },
                    {
                        path: 'uploadPtlConfirmation/:ticketId',
                        component: LoopbackComponent,
                        data: { navState: 'tm.trialSetup.uploadPtlConfirmation' }
                    },
                    {
                        path: 'systemOnTrial',
                        component: LoopbackComponent,
                        data: { navState: 'tm.trialSetup.systemOnTrial' }
                    }
                ]
            },
            {
                path: 'navReports',
                component: LoopbackComponent,
                data: { navState: 'tm.navReports' }
            },
            TM_REPORTS_ROUTES,
            {
                path: 'discovery',
                canDeactivate: [OldSitePendingChangesGuard],
                component: LoopbackComponent,
                data: { navState: 'tm.discovery' }
            },
            {
                path: 'myDefects',
                component: LoopbackComponent,
                data: { navState: 'tm.myDefects' }
            },
            {
                path: 'myDevIssues',
                component: LoopbackComponent,
                data: { navState: 'tm.myDevIssues' }
            }
        ]
    },
    {
        path: 'tm/discovery/chrome-extension',
        component: LoopbackComponent,
        canActivate: [ForesightDirectLinkToAnalysisGuard]
    },
    {
        path: 'sf/discovery',
        component: LoopbackComponent,
        canActivate: [ForesightDirectLinkToFtsGuard]
    }
];
